export default "__VITE_ASSET__B8aRXKMe__"